import request from 'project-config/services/request/request'
import { IGetTransferServerLineListParams, IGetTransferServerLineList } from './type'

export const RaysyncAPI = Object.freeze({
  getRaysyncSoftInfo: () => {
    return request.post<string[]>('/api/rendering/user/getSoftPath')
  },
  getTransferServerLineList: (params: IGetTransferServerLineListParams, option?: any) => {
    return request.post<IGetTransferServerLineList[]>(
      '/api/rendering/task/transfer/getTransferServerLineList',
      params,
      option,
    )
  },
})
